import { render, staticRenderFns } from "./fullPageShell.vue?vue&type=template&id=bd43cdc6&scoped=true"
import script from "./fullPageShell.vue?vue&type=script&lang=js"
export * from "./fullPageShell.vue?vue&type=script&lang=js"
import style0 from "./fullPageShell.vue?vue&type=style&index=0&id=bd43cdc6&prod&scoped=true&lang=scss"
import style1 from "./fullPageShell.vue?vue&type=style&index=1&id=bd43cdc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd43cdc6",
  null
  
)

export default component.exports